<div class="side-menu cursor-auto">
  <p-sidebar
    (onHide)="closeMenu()"
    [(visible)]="display"
    [baseZIndex]="8"
    [position]="lang === 'ar' ? 'right' : 'left'"
  >
    <div class="flex flex-column align-items-start w-full">
      <div *ngIf="mobileCategoriesStack.length === 0" class="section px-2 py-4">
        <a (click)="closeMenu()" class="no-underline" routerLink="/">
          <div class="title cursor-pointer">
            {{ "sideMenu.home" | translate }}
          </div>
        </a>
      </div>
      <div class="section px-2 py-4">
        <div
          *ngIf="mobileCategoriesStack.length === 0"
          class="title cursor-pointer"
        >
          {{ "sideMenu.categories" | translate }}
        </div>
        <div
          (click)="setPreviousMobileCategories()"
          *ngIf="mobileCategoriesStack.length > 0"
          class="title cursor-pointer"
        >
          <em class="fa fa-angle-left"></em>
          {{
            mobileCategoriesStack[mobileCategoriesStack.length - 1].categoryName
          }}
        </div>

        <!-- cat test: {{ screenWidth }} -->

        <div *ngIf="screenWidth > 620" class="w-100">
          <div
            (mouseenter)="
              assignSubCategories(category.categories, category.categoryName)
            "
            *ngFor="let category of categories"
            class="category category-drop-item cursor-pointer my-2"
          >
            <a
              (click)="goToCategories(category.id, category)"
              *ngIf="category.categories.length === 0"
              style="text-align: start"
            >
              {{ category.categoryName }}
            </a>
            <a *ngIf="category.categories.length > 0" style="text-align: start">
              {{ category.categoryName }}
            </a>
            <em
              *ngIf="category.categories.length > 0"
              class="fa fa-angle-right"
            ></em>
            <ul
              *ngIf="false && category.categories.length"
              class="dashed list-space mt-2"
            >
              <li *ngFor="let item of category.categories">
                <a (click)="goToCategories(item.id, item)">{{
                  item.categoryName
                }}</a>
                <ul *ngIf="item.categories.length" class="dashed mt-2">
                  <li *ngFor="let item1 of item.categories">
                    <a (click)="goToCategories(item1.id, item1)">{{
                      item1.categoryName
                    }}</a>
                    <ul *ngIf="item1.categories.length" class="dashed mt-2">
                      <li *ngFor="let item2 of item1.categories">
                        <a (click)="goToCategories(item2.id, item2)">{{
                          item2.categoryName
                        }}</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div *ngIf="screenWidth <= 620" class="w-100">
          <div
            *ngFor="let category of mobileCategories"
            class="category category-drop-item cursor-pointer my-2"
          >
            <a
              (click)="goToCategories(category.id, category)"
              *ngIf="category.categories.length === 0"
              style="text-align: start"
            >
              {{ category.categoryName }}
            </a>

            <a
              (click)="selectMobileCategories(category)"
              *ngIf="category.categories.length > 0"
              style="text-align: start"
            >
              {{ category.categoryName }}
            </a>
            <em
              (click)="selectMobileCategories(category)"
              *ngIf="category.categories.length > 0"
              class="fa fa-angle-right"
            ></em>
          </div>
        </div>

        <a
          *ngIf="mobileCategoriesStack.length === 0"
          class="category cursor-pointer my-2"
          routerLink="/categories"
        >
          {{ "sideMenu.browseAllCategories" | translate }}</a
        >
      </div>
      <div
        *ngIf="tenantId != '3' && mobileCategoriesStack.length === 0"
        class="section px-2 py-4"
      >
        <div class="title cursor-pointer">
          {{ "sideMenu.merchants" | translate }}
        </div>
        <a (click)="closeMenu()" class="no-underline" routerLink="/merchants">
          <div class="category cursor-pointer my-1">
            {{ "sideMenu.allMerchants" | translate }}
          </div>
        </a>
      </div>
      <div *ngIf="mobileCategoriesStack.length === 0" class="section px-2 py-4">
        <div class="title cursor-pointer">
          {{ "sideMenu.help" | translate }}
        </div>
        <a (click)="closeMenu()" class="no-underline" routerLink="/account">
          <div class="category cursor-pointer my-1">
            {{ "sideMenu.yourAccount" | translate }}
          </div>
        </a>
        <div class="category cursor-pointer my-1">
          {{ "sideMenu.customerService" | translate }}
        </div>
        <a
          (click)="closeMenu()"
          *ngIf="!loggedIn"
          class="no-underline"
          routerLink="/login"
        >
          <div class="category cursor-pointer my-1">
            {{ "sideMenu.signIn" | translate }}
          </div>
        </a>
        <a
          (click)="closeMenu(); logOut()"
          *ngIf="loggedIn"
          class="no-underline"
        >
          <div class="category cursor-pointer my-1">
            {{ "sideMenu.signOut" | translate }}
          </div>
        </a>
      </div>
    </div>
  </p-sidebar>

  <div *ngIf="display && subCategories.length > 0" class="drop-sub-categories">
    <h4 class="sub-cat-title">{{ subCatNames[0] }}</h4>
    <div
      (mouseenter)="
        assignSubCategories2(category.categories, category.categoryName)
      "
      *ngFor="let category of subCategories"
      class="category category-sub-drop-item cursor-pointer my-2"
    >
      <a
        (click)="goToCategories(category.id, category)"
        *ngIf="category.categories.length === 0"
        style="text-align: start"
      >
        {{ category.categoryName }}
      </a>
      <a *ngIf="category.categories.length > 0" style="text-align: start">
        {{ category.categoryName }}
      </a>
      <em *ngIf="category.categories.length > 0" class="fa fa-angle-right"></em>
    </div>
  </div>

  <div
    *ngIf="display && subCategories2.length > 0"
    class="drop-sub-categories sub-category-second"
    style="margin-left: 601px"
  >
    <h4 class="sub-cat-title">{{ subCatNames[1] }}</h4>
    <div
      (mouseenter)="
        assignSubCategories3(category.categories, category.categoryName)
      "
      *ngFor="let category of subCategories2"
      class="category category-sub-drop-item cursor-pointer my-2"
    >
      <a
        (click)="goToCategories(category.id, category)"
        *ngIf="category.categories.length === 0"
        style="text-align: start"
      >
        {{ category.categoryName }}
      </a>
      <a *ngIf="category.categories.length > 0" style="text-align: start">
        {{ category.categoryName }}
      </a>
      <em *ngIf="category.categories.length > 0" class="fa fa-angle-right"></em>
    </div>
  </div>

  <div
    *ngIf="display && subCategories3.length > 0"
    class="drop-sub-categories sub-category-three"
    style="margin-left: 906px"
  >
    <h4 class="sub-cat-title">{{ subCatNames[2] }}</h4>
    <div
      *ngFor="let category of subCategories3"
      class="category category-sub-drop-item cursor-pointer my-2"
    >
      <a
        (click)="goToCategories(category.id, category)"
        *ngIf="category.categories.length === 0"
        style="text-align: start"
      >
        {{ category.categoryName }}
      </a>
      <a *ngIf="category.categories.length > 0" style="text-align: start">
        {{ category.categoryName }}
      </a>
      <em *ngIf="category.categories.length > 0" class="fa fa-angle-right"></em>
    </div>
  </div>

  <em
    (click)="openMenu()"
    class="pi pi-bars pi-white"
    style="display: flex; margin-top: 2px"
    ><span *ngIf="!isShowAll" class="bars-all"> {{ "sideMenu.all" | translate }}</span>
    <span class="ml-2 mr-1 pi-pi-text">
      <ng-content></ng-content>
    </span>
  </em>
</div>
